import { useEffect } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../../meet/NavLinks';
import MyMeetsNavLinks from '../../myMeets/MyMeetsNavLinks';

import useOmeMeetOrgUnitEntryInfoData from '../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetData from '../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryData from '../../../state/omeMeetEntry/UseOmeMeetEntryData';
import useOmeMeetOrgUnitEntryData from '../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetTeamEntryData from '../../../state/omeMeetTeamEntry/UseOmeMeetTeamEntryData';
import useMyMeetsFiltersData from '../../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useOUAdminEntryContextData from '../../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';

const useOUAdminEntryContextView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { meetState } = useMeetData();
  const { omeMeetOrgUnitEntryInfoState, clearOmeMeetOrgUnitEntryInfoObjData } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetState, clearOmeMeetArrayData } = useOmeMeetData();
  const { omeMeetEntryState } = useOmeMeetEntryData();
  const { omeMeetOrgUnitEntryState, clearOmeMeetOrgUnitEntryObjData, clearOmeMeetOrgUnitEntryArrayData } = useOmeMeetOrgUnitEntryData();
  const { resetOmeMeetTeamEntryState } = useOmeMeetTeamEntryData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { oUAdminEntryContextState, setOUAdminEntryContextState } = useOUAdminEntryContextData();
  const { clearArrayData } = usePersonOrgRoleData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const BACK_TO_LABELS = {
    entryBackToLabel: omeMeetState.route === '' ? 'Back to My Meets' : 'Back to Team Entry Management',
  };

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    clearOmeMeetOrgUnitEntryInfoObjData();
    clearOmeMeetOrgUnitEntryObjData();
    clearOmeMeetOrgUnitEntryArrayData();
    clearOmeMeetArrayData();
    resetOmeMeetTeamEntryState();
    clearArrayData();

    if (omeMeetState.route === '') {
      //OME Route
      navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
    }
    else {
      //Meet Route
      setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
      navigate(NavLinks.MEET_ENTRY_TEAM, { state: { goToMeet: true } });
    }
  };

  function getBackToLabel() {
    return BACK_TO_LABELS.entryBackToLabel;
  }

  useEffect(() => {
    setOUAdminEntryContextState({ ...oUAdminEntryContextState, isReadOnly: location.state?.isReadOnly ?? true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    oUAdminEntryContextState,
    omeMeetOrgUnitEntryInfoState,
    meetState,
    omeMeetState,
    omeMeetEntryState,
    omeMeetOrgUnitEntryState,
    backToLabel: getBackToLabel(),
    onBackClicked
  };
};

export default useOUAdminEntryContextView;